import { ShoppingBag } from "lucide-react";
import { useCollection } from "@/hooks/useCollection";
import { rupiah, sum, todayIso, fmtDate, monthKey, EXPENSE_CATS } from "@/lib/format";
import { EntryForm, ItemList, Section, Stat } from "./shared";

export default function ExpenseTab() {
  const { items, add, remove } = useCollection("expenses");
  const m = monthKey();
  const month = items.filter((x) => x.date.startsWith(m));
  const top = EXPENSE_CATS.map((c) => [c, sum(month.filter((x) => x.category === c))]).sort((a, b) => b[1] - a[1])[0];

  return (
    <div className="space-y-4" data-testid="duitku-expense">
      <div className="grid grid-cols-2 gap-3">
        <Stat label="Pengeluaran bulan ini" value={rupiah(sum(month))} tone="text-rose-500" testid="expense-month-total" />
        <Stat label="Paling boros" value={top && top[1] ? top[0] : "-"} testid="expense-top-cat" />
      </div>
      <Section title="Catat pengeluaranku">
        <EntryForm
          testid="expense-form"
          initial={{ category: "Makan", amount: "", date: todayIso(), note: "" }}
          fields={[
            { name: "category", label: "Kategori", type: "select", options: EXPENSE_CATS.map((c) => [c, c]), keep: true },
            { name: "amount", label: "Jumlah (Rp)", type: "number", required: true, min: 1 },
            { name: "date", label: "Tanggal", type: "date", required: true, keep: true },
            { name: "note", label: "Catatan", placeholder: "mis. Kopi susu" },
          ]}
          onSubmit={(v) => add({ ...v, amount: Number(v.amount) })}
        />
        <div className="mt-4">
          <ItemList
            testid="expense-list"
            items={items}
            onDelete={remove}
            empty="Belum ada pengeluaran tercatat."
            render={(it) => ({
              icon: <span className="w-9 h-9 rounded-2xl bg-sky-100 text-sky-500 grid place-items-center shrink-0"><ShoppingBag className="w-4 h-4" /></span>,
              title: it.note || it.category,
              subtitle: `${it.category} · ${fmtDate(it.date)}`,
              right: <span className="text-sm font-semibold text-rose-500 whitespace-nowrap">-{rupiah(it.amount)}</span>,
            })}
          />
        </div>
      </Section>
    </div>
  );
}
